import React from 'react';
import { cn } from '../utils/cn';
export const EmptyState = React.forwardRef(function EmptyState(
  { icon, title, description, action, className, ...props },
  ref,
) {
  return (
    <div
      ref={ref}
      className={cn('flex flex-col items-center justify-center py-12 text-center', className)}
      {...props}
    >
      {icon && <div className="mb-4 text-fg-tertiary">{icon}</div>}
      <h3 className="text-lg font-semibold text-fg">{title}</h3>
      {description && <p className="mt-1 max-w-sm text-sm text-fg-tertiary">{description}</p>}
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
});
